import { TableHeader } from "components"
import { useFormContext, useWatch } from "react-hook-form"
import { FormInvoiceType } from "../types"
import { convertNumber, useEmployee, useHandleAuth } from "utils"
import { calculateSummaryInvoice } from "../utils/functions"

export function PrintContent({
    withImagePrint,
    withValue
}: {
    withImagePrint: boolean
    withValue: boolean
}) {
    const { formState: { defaultValues }, control, watch } = useFormContext<FormInvoiceType>()
    const { userTokenData } = useHandleAuth()
    const userToken = userTokenData()

    const { dataEmployee } = useEmployee()

    const [freight, invoice_detail, total_payment] = useWatch({
        control,
        name: ["freight", "invoice_detail", "total_payment"]
    })
    const summary = calculateSummaryInvoice({
        invoice_detail,
        freight,
        total_payment
    })


    const empoloyeName = dataEmployee?.find((item) => item.value === watch("employee_id")?.toString())?.label

    return (
        <>
            <table className="table table-bordered">
                <TableHeader>
                    <tr className="bg-black text-white">
                        <th>#</th>
                        {withImagePrint &&
                            defaultValues?.approval_status === 4 &&
                            <th>PICTURE</th>
                        }

                        {withValue && <th>CODE</th>}
                        <th>DESCRIPTION</th>
                        {withValue && <th>PRICE</th>}
                        {!withValue && <th>ORDER</th>}
                        {!withValue && <th>BACKORDER</th>}
                        <th>SHIPPED</th>
                        <th>UNIT</th>
                        {withValue && <th>DISC</th>}
                        {withValue && <th>TOTAL</th>}
                        {withValue && <th>TAX</th>}
                    </tr>
                </TableHeader>

                <tbody>
                    {defaultValues?.invoice_detail?.map((item: any, key) => {
                        const totalBackOrder = (item?.qty_order ?? 0) - (item?.delivered ?? 0)
                        const totalBackOrderInvoice = (item?.qty_order ?? 0) - (item?.quantity_invoice ?? 0)
                        const imagePath = `${process.env.REACT_APP_BASE_URL_API}/getimage/?imgpath=${item.product_foto}`

                        return (
                            <tr>
                                <td className="text-center">{key + 1}</td>
                                {withImagePrint &&
                                    defaultValues?.approval_status === 4 &&
                                    <td width={150}>
                                        <img
                                            width={150}
                                            height={150}
                                            src={imagePath}
                                            alt={item?.description}
                                        />
                                    </td>
                                }

                                {withValue && <td>{item?.product_barcode}</td>}

                                <td>
                                    <div className="mb-4">{item?.description}</div>
                                </td>

                                {withValue && <td className="text-right">
                                    {convertNumber(item?.price_measure ?? 0).intoCurrency}
                                </td>
                                }


                                {!withValue && <td className="text-right">
                                    {convertNumber(item?.qty_order ?? 0).intoCurrency}
                                </td>
                                }

                                {!withValue &&
                                    <td className="text-right">
                                        {
                                            defaultValues.approval_status !== 4 ?
                                                convertNumber(totalBackOrder).intoCurrency
                                                : convertNumber(totalBackOrderInvoice).intoCurrency
                                        }
                                    </td>
                                }

                                <td className="text-right">
                                    {convertNumber(item?.quantity_invoice ?? 0).intoCurrency}
                                </td>
                                <td>{item?.mr_unit_name}</td>

                                {withValue && <td className="text-right">
                                    {convertNumber(item?.discount ?? 0).intoNormalAmount} %
                                </td>
                                }

                                {withValue && <td className="text-right">
                                    {convertNumber(item?.total ?? 0).intoCurrency}
                                </td>
                                }

                                {withValue && <td className="text-right">
                                    {item?.tax_name}
                                </td>
                                }


                            </tr>
                        )
                    })}
                </tbody>
            </table>


            <section>
                {!withValue && (
                    <section className="grid grid-cols-5 items-stretch gap-5">
                        <section className="col-span-2 flex flex-col gap-3">
                            <table className="table table-bordered">
                                <tbody>
                                    <tr className="bg-black text-white font-bold">
                                        <td>Additional Notes:</td>
                                    </tr>

                                    <tr className="min-h-[300px]">
                                        <td>{defaultValues?.memo}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <div />
                    </section>
                )}
                <section className="flex flex-col gap-4">
                    {withValue && (
                        <div className="flex justify-end">
                        <table className="border-collapse">
                            <tbody>
                                <tr>
                                    <td className="pr-6 whitespace-nowrap">SUBTOTAL</td>
                                    <td className="text-right">
                                        {convertNumber(summary?.subtotal ?? 0).intoCurrency}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="pr-6 whitespace-nowrap">FREIGHT</td>
                                    <td className="text-right">
                                        {convertNumber(summary?.freight ?? 0).intoCurrency}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="pr-6 whitespace-nowrap">TAX</td>
                                    <td className="text-right">
                                        {convertNumber(summary?.tax ?? 0).intoCurrency}
                                    </td>
                                </tr>

                                <tr className="border-t-2 border-black font-bold">
                                    <td className="pr-6 whitespace-nowrap">TOTAL AMOUNT</td>
                                    <td className="text-right ">
                                        {convertNumber(summary?.totalAmount ?? 0).intoCurrency}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    )}
                    
                    <div className="flex justify-between mt-16">
                        <div className="text-center w-[260px]">
                            <p className="mb-20 font-semibold">
                                {userToken?.company_name}
                            </p>

                            {/* <div className="border-t border-dashed border-black pt-2"></div> */}

                            <div className="mt-4 italic">
                                {`( ${empoloyeName} )`}
                            </div>

                        </div>

                        <div className="text-center w-[260px]">
                            <p className="mb-20 font-semibold">
                                CUSTOMER
                            </p>

                            {/* <div className="border-t border-dashed border-black"></div> */}

                            <div className="mt-4 italic">
                                {`( ${watch('customer_name')} )`}
                            </div>

                        </div>
                    </div>
                </section>
            </section>
        
        </>
    )
}

